import { useQuery } from "@tanstack/react-query";
import { api } from "@shared/http/client";
import type { AuditEntry, AuditQuery } from "@/types/audit";

export const auditKeys = {
  all: ["audit"] as const,
  list: (q: AuditQuery) => [...auditKeys.all, "list", q] as const,
};

export function useAudit(query: AuditQuery = {}) {
  return useQuery({
    queryKey: auditKeys.list(query),
    queryFn: () => {
      const params = new URLSearchParams();
      if (query.from)       params.set("from", query.from);
      if (query.to)         params.set("to", query.to);
      if (query.actor)      params.set("actor", query.actor);
      if (query.accion)     params.set("accion", query.accion);
      if (query.targetType) params.set("targetType", query.targetType);
      if (query.limit)      params.set("limit", String(query.limit));
      const qs = params.toString();
      return api.get<AuditEntry[]>(`/audit${qs ? "?" + qs : ""}`);
    },
  });
}
